module.exports = __webpack_public_path__ + "static/media/QR.4f094056.png";